const MAINTENANCE_STORE_SELECTORS = {
    DEPARTMENT: "departments",
    EMPLOYEE_POSITION: "employeePositions",
    EMPLOYEE_PAY_CLASS: "employeePayClasses",
    LOAN_TYPE: "loanTypes",
    LEAVE_TYPE: "leaveTypes",
    ORGANISATION: "organisations",
    SIGNATORY: "signatories",
    TRAININGS: "trainings",
    HOLIDAY: "holidays",
    USER_GROUP: "userGroups",
    EMPLOYMENT_STATUS: "employmentStatuses",
    TAX_SCHEDULE: "taxBrackets"
};

export default MAINTENANCE_STORE_SELECTORS;
